<ng-container *ngIf="rebookingState$ | async as state">

    <div class="header">
        <mat-form-field>
            <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <div class="bab-button">
            <button mat-raised-button
                    matTooltip="{{ 'app.component.cost-center-cost.operational-accounting-sheet.info.label' | translate }}"
                    [disabled]="selectedCostAccounting === undefined || selectedCostAccounting.state !== costAccountingState.COST_TYPE_ACCOUNTING"
                    (click)="onCalculateOperationalAccountingSheet()">{{ "app.component.cost-center-cost.operational-accounting-sheet.label" | translate }}</button>
        </div>
    </div>

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
        <ng-container matColumnDef="costCenterName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.component.cost-center-cost.cost-center.label" | translate }}</th>
            <td mat-cell *matCellDef="let costCenterCost">
                <button mat-icon-button aria-label="expand row" (click)="toggleExpand(costCenterCost); $event.stopPropagation()">
                    <mat-icon *ngIf="!isExpandedMap[costCenterCost.costCenter.id]">keyboard_arrow_down</mat-icon>
                    <mat-icon *ngIf="isExpandedMap[costCenterCost.costCenter.id]">keyboard_arrow_up</mat-icon>
                </button>
                {{costCenterCost.costCenter.name}}
            </td>
        </ng-container>

        <ng-container matColumnDef="costCt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.component.cost-center-cost.cost.label" | translate }}</th>
            <td mat-cell *matCellDef="let costCenterCost">
                {{costCenterCost.costCt / 100 | number: '1.2-2' : 'de-DE' }} €
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedRow">
            <td mat-cell *matCellDef="let costCenterCost" [attr.colspan]="layout.costCenterCostColumns.length">
                <div class="costCenterCost-detail" [@detailExpand]="isExpandedMap[costCenterCost.costCenter.id] ? 'expanded' : 'collapsed'">
                    <table mat-table [dataSource]="costCenterCost.distributions">

                        <ng-container matColumnDef="costTypeName">
                            <th mat-header-cell *matHeaderCellDef>{{ "app.component.cost-center-cost.cost-type.label" | translate }}</th>
                            <td
                                style="padding-left: 60px"
                                mat-cell *matCellDef="let distribution">{{distribution.costType.name}}</td>
                        </ng-container>
                        <ng-container matColumnDef="distributionCost">
                            <th mat-header-cell *matHeaderCellDef>{{ "app.component.cost-center-cost.cost.label" | translate }}</th>
                            <td mat-cell *matCellDef="let distribution">{{distribution.costCt / 100 | number: '1.2-2' : 'de-DE' }} €</td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td class="actions-column" mat-cell *matCellDef="let distribution">
                                <button mat-icon-button
                                        color="primary"
                                        matTooltip="{{ 'app.component.cost-center-cost.actions.history.label' | translate }}"
                                        (click)="onOpenHistoryDialog(distribution)">
                                    <mat-icon>history</mat-icon>
                                </button>
                                <button mat-icon-button
                                        color="primary"
                                        matTooltip="{{ 'app.component.cost-center-cost.actions.rebooking.label' | translate }}"
                                        [disabled]="distribution.costCt === 0 || selectedCostAccounting.state !== costAccountingState.COST_TYPE_ACCOUNTING"
                                        (click)="onOpenRebookingDialog(distribution)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: layout.distributionsColumns"></tr>

                    </table>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="layout.costCenterCostColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let costCenterCost; columns: layout.costCenterCostColumns;"
            class="costCenterCostRow"
            [class.example-expanded-row]="isExpandedMap[costCenterCost.costCenter.id]"
            (click)="toggleExpand(costCenterCost); $event.stopPropagation()"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedRow']" class="distributionRow"></tr>

    </table>

</ng-container>
